import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

export type TeamLogoShape = 'square' | 'round';

type TeamLogoContainerProps = {
  size?: number;
  shape?: TeamLogoShape;
};

/** Эти пропсы — наши, а не атрибуты div: `size` и `shape` у DOM-узла были бы лишними атрибутами. */
const CUSTOM_PROPS = ['size', 'shape'];

export const TeamLogoContainer = styled('div', {
  shouldForwardProp: (prop) => !CUSTOM_PROPS.includes(prop as string),
})<TeamLogoContainerProps>`
  width: ${({ size }) => size ?? 40}px;
  height: ${({ size }) => size ?? 40}px;

  display: flex;
  position: relative;
  flex-shrink: 0;
  justify-content: center;
  box-sizing: border-box;

  /* Квадрат с рамкой — как везде в списках; круг — на белой подложке, без рамки, с обрезкой по контуру. */
  ${({ shape }) =>
    shape === 'round'
      ? `
    border-radius: ${theme.radii.pill};
    background: ${theme.colors.SurfaceCard};
    overflow: hidden;
  `
      : `
    border: 1px solid ${theme.colors.LineSubtle};
    border-radius: ${theme.radii.card};
    padding: 4px;
  `}
`;

export const TeamLogoImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
